import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import DefaultLayout from "../../../layouts/DefaultLayout";
import { withRouter } from "react-router-dom";
import { Card, Col, Row } from "antd";

/**
 * A simple thank you page.
 */
@inject("context")
@withRouter
@observer
class ThankYou extends Component {
	render() {
		return (
			<DefaultLayout>
				<Row>
					<Col xs={24}>
						<Card
							title={
								<h1>
Many thanks for your purchase. We can confirm your policy is now in force from the date requested. We have emailed your policy documents to the designated email address provided.
For additional information, please contact us at 0207 078 7540 or email us at info@activitybusinesscover.co.uk
								</h1>
							}
						>
							<Row>
								<Col xs={24} />
							</Row>
						</Card>
					</Col>
				</Row>
			</DefaultLayout>
		);
	}
}

export default ThankYou;
